(function () {

  function initManhattanChargingFinder() {

    const root = document.querySelector('.lc-guide');
    if (!root) return;


    /* =========================================================
       PRODUCT DATA
       ========================================================= */

    const products = [

      {
        id: "181297",
        name: "7-Port USB-C Desktop-Ladeschrank - 65 W pro Port",
        type: "usb",
        ports: 7,
        watts: 65,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["key"],
        mounts: ["desktop", "wall"],
        dimensions: [402, 290, 50],
        url: "https://manhattanproducts.de/products/manhattan-de-7-port-usb-c-desktop-ladeschrank-315-w-181297"
      },

      {
        id: "181488",
        name: "10-Port USB-C Desktop-Ladeschrank - 30 W pro Port",
        type: "usb",
        ports: 10,
        watts: 30,
        devices: ["chromebook", "tablet", "phone"],
        locks: ["key", "pin"],
        mounts: ["desktop"],
        dimensions: [330, 25, 235],
        url: "https://manhattanproducts.de/products/manhattan-de-10-port-usb-c-desktop-ladeschrank-30w-pro-port-181488"
      },

      {
        id: "181266",
        name: "12-Port USB-C Desktop-Ladeschrank - 65 W pro Port",
        type: "usb",
        ports: 12,
        watts: 65,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["key", "pin"],
        mounts: ["desktop", "wall", "rolls"],
        dimensions: [395, 32.5, 290],
        url: "https://manhattanproducts.de/products/manhattan-de-12-port-usb-c-desktop-ladeschrank-780-w-181266"
      },

      {
        id: "181495",
        name: "20-Port USB-C Ladeschrank auf Rollen - 30 W pro Port",
        type: "usb",
        ports: 20,
        watts: 30,
        devices: ["chromebook", "tablet", "phone"],
        locks: ["key", "pin"],
        mounts: ["floor", "rolls"],
        dimensions: [330, 25, 235],
        url: "https://manhattanproducts.de/products/manhattan-de-20-port-usb-c-ladeschrank-auf-rollen-30w-pro-port-181495"
      },

      {
        id: "181273",
        name: "30-Port USB-C Ladeschrank auf Rollen - 65 W pro Port",
        type: "usb",
        ports: 30,
        watts: 65,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["key", "pin"],
        mounts: ["floor", "rolls"],
        dimensions: [400, 34, 275],
        url: "https://manhattanproducts.de/products/manhattan-de-30-port-usb-c-ladeschrank-auf-rollen-1920-w-181273"
      },

      {
        id: "181471",
        name: "30-Port USB-C Ladeschrank auf Rollen - 30 W pro Port",
        type: "usb",
        ports: 30,
        watts: 30,
        devices: ["chromebook", "tablet", "phone"],
        locks: ["key", "pin"],
        mounts: ["floor", "rolls"],
        dimensions: [330, 25, 235],
        url: "https://manhattanproducts.de/products/manhattan-de-30-port-usb-c-ladeschrank-auf-rollen-30w-pro-port-181471"
      },

      {
        id: "102353",
        name: "32-Port USB-C Ladeschrank auf Rollen - 18 W pro Port",
        type: "usb",
        ports: 32,
        watts: 18,
        devices: ["chromebook", "tablet"],
        locks: ["key"],
        mounts: ["floor", "rolls"],
        dimensions: [404, 27.6, 283],
        url: "https://manhattanproducts.de/products/manhattan-de-32-port-usb-c-ladeschrank-auf-rollen-576-w-102353"
      },

      {
        id: "715942",
        name: "10-Port USB-C Desktop-Ladeschrank - 18 W pro Port",
        type: "usb",
        ports: 10,
        watts: 18,
        devices: ["tablet", "phone"],
        locks: ["key"],
        mounts: ["desktop"],
        dimensions: [264, 22, 235],
        url: "https://manhattanproducts.de/products/manhattan-de-10-port-usb-c-desktop-ladeschrank-180-w-715942"
      },

      {
        id: "715959",
        name: "20-Port USB-C Desktop-Ladeschrank - 18 W pro Port",
        type: "usb",
        ports: 20,
        watts: 18,
        devices: ["tablet", "phone"],
        locks: ["key"],
        mounts: ["desktop"],
        dimensions: [264, 22, 235],
        url: "https://manhattanproducts.de/products/manhattan-de-20-port-usb-c-desktop-ladeschrank-360-w-715959"
      },

      {
        id: "181310",
        name: "USB-C Ladeschrank mit 11 Schließfächern - 65 W pro Fach",
        type: "usb",
        ports: 11,
        watts: 65,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["user-pin"],
        mounts: ["wall", "floor"],
        dimensions: [448, 328, 120],
        url: "https://manhattanproducts.de/products/manhattan-de-usb-c-ladeschrank-mit-11-schliessfachern-500-w-181310",
        pedestal: {
          id: "181303",
          url: "https://manhattanproducts.de/products/manhattan-de-anti-diebstahl-sockel-fur-ladeschrank-mit-11-schliessfachern-181310-181303"
        }
      },

      {
        id: "181327",
        name: "USB-C Ladeschrank mit 16 Schließfächern - 65 W pro Fach",
        type: "usb",
        ports: 16,
        watts: 65,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["user-pin"],
        mounts: ["wall", "floor"],
        dimensions: [328, 428, 100],
        url: "https://manhattanproducts.de/products/manhattan-de-usb-c-ladeschrank-mit-16-schliessfachern-850-w-181327",
        pedestal: {
          id: "181358",
          url: "https://manhattanproducts.de/products/manhattan-de-anti-diebstahl-sockel-fur-ladeschrank-mit-16-schliessfachern-181327-181358"
        }
      },

      {
        id: "181334",
        name: "USB-C Ladeschrank mit 16 Schließfächern - 30 W pro Fach",
        type: "usb",
        ports: 16,
        watts: 30,
        devices: ["tablet", "phone"],
        locks: ["user-pin"],
        mounts: ["wall", "floor"],
        dimensions: [328, 220, 100],
        url: "https://manhattanproducts.de/products/manhattan-de-usb-c-ladeschrank-mit-16-schliessfachern-500-w-181334",
        pedestal: {
          id: "181341",
          url: "https://manhattanproducts.de/products/manhattan-de-anti-diebstahl-sockel-fur-ladeschrank-mit-16-schliessfachern-181334-181341"
        }
      },

      {
        id: "181280",
        name: "Desktop-Ladeschrank mit 7 Steckdosen",
        type: "ac",
        ports: 7,
        watts: null,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["key"],
        mounts: ["desktop", "wall"],
        dimensions: [402, 290, 50],
        url: "https://manhattanproducts.de/products/manhattan-de-desktop-ladeschrank-mit-7-steckdosen-181280"
      },

      {
        id: "181204",
        name: "Desktop-Ladeschrank mit 10 Steckdosen",
        type: "ac",
        ports: 10,
        watts: null,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["key"],
        mounts: ["desktop", "wall"],
        dimensions: [430, 35, 272],
        url: "https://manhattanproducts.de/products/manhattan-de-mh-10-bay-ac-charging-cabinet-eu-black-181204"
      },

      {
        id: "180924",
        name: "Desktop-Ladeschrank mit 10 Steckdosen und Zahlencode",
        type: "ac",
        ports: 10,
        watts: null,
        devices: ["laptop", "chromebook", "tablet", "phone"],
        locks: ["key", "pin"],
        mounts: ["desktop", "wall"],
        dimensions: [430, 28.5, 285],
        url: "https://manhattanproducts.de/products/manhattan-de-ladeschrank-mit-10-steckdosen-180924"
      },

      {
        id: "181129",
        name: "Ladeschrank mit 20 Steckdosen",
        type: "ac",
        ports: 20,
        watts: null,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["key"],
        mounts: ["desktop", "floor", "rolls"],
        dimensions: [400, 27, 275],
        mountNote: "Die enthaltenen Rollen können gegen die beiliegenden Kunststofffüße ausgetauscht werden.",
        url: "https://manhattanproducts.de/products/manhattan-de-ladeschrank-auf-rollen-mit-20-steckdosen-181129"
      },

      {
        id: "181198",
        name: "Ladeschrank auf Rollen mit 30 Steckdosen",
        type: "ac",
        ports: 30,
        watts: null,
        devices: ["laptop", "chromebook", "tablet"],
        locks: ["key"],
        mounts: ["floor", "rolls"],
        dimensions: [400, 34, 275],
        url: "https://manhattanproducts.de/products/manhattan-de-ladeschrank-auf-rollen-mit-30-steckdosen-181198"
      }

    ];


    /* =========================================================
       ELEMENTS
       ========================================================= */

    const form = root.querySelector('#lcFinderForm');
    const resetButton = root.querySelector('#lcFinderReset');
    const powerField = root.querySelector('#lcPowerField');
    const status = root.querySelector('#lcFilterStatus');
    const resultSummary = root.querySelector('#lcResultSummary');
    const resultPlaceholder = root.querySelector('#lcResultPlaceholder');
    const resultList = root.querySelector('#lcResultList');

    const fields = {
      type: root.querySelector('#lcType'),
      device: root.querySelector('#lcDevice'),
      power: root.querySelector('#lcPower'),
      count: root.querySelector('#lcCount'),
      lock: root.querySelector('#lcLock'),
      mount: root.querySelector('#lcMount')
    };


    /* =========================================================
       CASCADE ORDER / OPTIONS
       ========================================================= */

    const order = [
      "mount",
      "type",
      "device",
      "power",
      "count",
      "lock"
    ];

    const optionDefinitions = {

      type: [
        ["usb", "USB-C Power Delivery"],
        ["ac", "Steckdosen / eigene Netzteile"]
      ],

      device: [
        ["mixed", "Verschiedene Gerätetypen"],
        ["laptop", "Notebook / Laptop"],
        ["chromebook", "Chromebook"],
        ["tablet", "Tablet / iPad"],
        ["phone", "Smartphone"]
      ],

      power: [
        ["18", "mindestens 18 W"],
        ["30", "mindestens 30 W"],
        ["65", "mindestens 65 W"]
      ],

      count: [
        ["7", "mindestens 7"],
        ["10", "mindestens 10"],
        ["11", "mindestens 11"],
        ["12", "mindestens 12"],
        ["16", "mindestens 16"],
        ["20", "mindestens 20"],
        ["30", "mindestens 30"],
        ["32", "32"]
      ],

      lock: [
        ["key", "Schlüssel"],
        ["pin", "Schlüssel oder PIN / Zahlencode"],
        ["user-pin", "Benutzer-PIN je Schließfach"]
      ],

      mount: [
        ["rolls", "Auf Rollen"],
        ["floor", "Auf dem Boden / freistehend"],
        ["desktop", "Auf dem Schreibtisch"],
        ["wall", "An der Wand"]
      ]

    };

    const defaults = {
      type: ["any", "Keine Vorgabe"],
      device: ["any", "Keine Vorgabe"],
      power: ["0", "Keine Vorgabe"],
      count: ["1", "Keine Vorgabe"],
      lock: ["any", "Keine Vorgabe"],
      mount: ["any", "Keine Vorgabe"]
    };


    /* =========================================================
       MATCHING
       ========================================================= */

    function baseCriteria() {

      return {
        type: "any",
        device: "any",
        power: 0,
        count: 1,
        lock: "any",
        mount: "any"
      };

    }


    function readFieldIntoCriteria(criteria, fieldName) {

      if (fieldName === "power") {

        criteria.power =
          Number(fields[fieldName].value || 0);

        return;

      }


      if (fieldName === "count") {

        criteria.count =
          Number(fields[fieldName].value || 1);

        return;

      }


      /*
       * "Verschiedene Gerätetypen" wird absichtlich
       * genauso behandelt wie "Keine Vorgabe".
       */
      if (
        fieldName === "device" &&
        fields[fieldName].value === "mixed"
      ) {

        criteria.device = "any";

        return;

      }


      criteria[fieldName] =
        fields[fieldName].value || "any";

    }


    function matchesCriteria(product, criteria) {

      if (
        criteria.type !== "any" &&
        product.type !== criteria.type
      ) {

        return false;

      }


      if (
        criteria.device !== "any" &&
        !product.devices.includes(criteria.device)
      ) {

        return false;

      }


      if (criteria.power > 0) {

        if (
          product.type !== "usb" ||
          !product.watts ||
          product.watts < criteria.power
        ) {

          return false;

        }

      }


      if (
        product.ports < criteria.count
      ) {

        return false;

      }


      if (
        criteria.lock !== "any" &&
        !product.locks.includes(criteria.lock)
      ) {

        return false;

      }


      if (
        criteria.mount !== "any" &&
        !product.mounts.includes(criteria.mount)
      ) {

        return false;

      }


      return true;

    }


    function criteriaBefore(fieldName) {

      const criteria =
        baseCriteria();

      const index =
        order.indexOf(fieldName);


      order
        .slice(0, index)
        .forEach(function (name) {

          readFieldIntoCriteria(
            criteria,
            name
          );

        });


      return criteria;

    }


    function currentCriteria() {

      const criteria =
        baseCriteria();


      order.forEach(function (name) {

        readFieldIntoCriteria(
          criteria,
          name
        );

      });


      return criteria;

    }


    /* =========================================================
       DYNAMIC OPTIONS
       ========================================================= */

    function optionIsPossible(
      fieldName,
      value,
      candidates
    ) {

      return candidates.some(
        function (product) {

          if (fieldName === "type") {

            return (
              product.type === value
            );

          }


          if (fieldName === "device") {

            /*
             * "Verschiedene Gerätetypen" schränkt
             * die Auswahl nicht ein.
             */
            if (value === "mixed") {

              return true;

            }

            return product.devices.includes(
              value
            );

          }


          if (fieldName === "power") {

            return (
              product.type === "usb" &&
              product.watts >= Number(value)
            );

          }


          if (fieldName === "count") {

            return (
              product.ports >= Number(value)
            );

          }


          if (fieldName === "lock") {

            return product.locks.includes(
              value
            );

          }


          if (fieldName === "mount") {

            return product.mounts.includes(
              value
            );

          }


          return true;

        }
      );

    }


    function rebuildSelect(fieldName) {

      const select =
        fields[fieldName];

      const selectedBefore =
        select.value;

      const criteria =
        criteriaBefore(fieldName);


      const candidates =
        products.filter(
          function (product) {

            return matchesCriteria(
              product,
              criteria
            );

          }
        );


      select.innerHTML = "";


      const defaultOption =
        document.createElement(
          "option"
        );

      defaultOption.value =
        defaults[fieldName][0];

      defaultOption.textContent =
        defaults[fieldName][1];

      select.appendChild(
        defaultOption
      );


      optionDefinitions[fieldName]
        .forEach(function (definition) {

          const value =
            definition[0];

          const label =
            definition[1];


          if (
            !optionIsPossible(
              fieldName,
              value,
              candidates
            )
          ) {

            return;

          }


          const option =
            document.createElement(
              "option"
            );

          option.value =
            value;

          option.textContent =
            label;

          select.appendChild(
            option
          );

        });


      const stillExists =
        Array.from(
          select.options
        ).some(function (option) {

          return (
            option.value ===
            selectedBefore
          );

        });


      if (stillExists) {

        select.value =
          selectedBefore;

      }

    }


    function resetField(fieldName) {

      fields[fieldName].value =
        defaults[fieldName][0];

    }


    function updatePowerVisibility() {

      const criteria =
        criteriaBefore("power");


      const candidates =
        products.filter(
          function (product) {

            return matchesCriteria(
              product,
              criteria
            );

          }
        );


      const hasUSB =
        candidates.some(
          function (product) {

            return (
              product.type === "usb"
            );

          }
        );


      if (!hasUSB) {

        powerField.hidden =
          true;

        fields.power.value =
          "0";

      } else {

        powerField.hidden =
          false;

      }

    }


    function updateStatus() {

      const candidates =
        products.filter(
          function (product) {

            return matchesCriteria(
              product,
              currentCriteria()
            );

          }
        );


      if (
        candidates.length ===
        products.length
      ) {

        status.textContent =
          "Alle " +
          products.length +
          " Ladeschränke stehen zur Auswahl.";

      } else if (
        candidates.length === 1
      ) {

        status.textContent =
          "Aktuell kommt 1 Ladeschrank infrage.";

      } else {

        status.textContent =
          "Aktuell kommen " +
          candidates.length +
          " Ladeschränke infrage.";

      }

    }


    function rebuildAfter(changedFieldName) {

      const changedIndex =
        order.indexOf(
          changedFieldName
        );


      /*
       * Alle nachfolgenden Felder zunächst
       * auf "Keine Vorgabe" zurücksetzen.
       */
      order
        .slice(changedIndex + 1)
        .forEach(function (fieldName) {

          resetField(fieldName);

        });


      /*
       * Danach nur noch logisch mögliche
       * Optionen neu aufbauen.
       */
      order
        .slice(changedIndex + 1)
        .forEach(function (fieldName) {

          rebuildSelect(
            fieldName
          );


          if (
            fieldName === "power"
          ) {

            updatePowerVisibility();

          }

        });


      updatePowerVisibility();

      updateStatus();

    }


    /* =========================================================
       RESULT LABELS
       ========================================================= */

    function lockLabel(product) {

      if (
        product.locks.includes(
          "user-pin"
        )
      ) {

        return (
          "Benutzer-PIN je Fach"
        );

      }


      if (
        product.locks.includes("key") &&
        product.locks.includes("pin")
      ) {

        return (
          "Schlüssel oder PIN"
        );

      }


      return "Schlüssel";

    }


    function formatDimension(value) {

      return String(value)
        .replace(".", ",");

    }


    function mountLabel(product) {

      const labels = [];


      if (
        product.mounts.includes(
          "rolls"
        )
      ) {

        labels.push(
          "Rollen"
        );

      }


      if (
        product.mounts.includes(
          "floor"
        )
      ) {

        labels.push(
          "Boden / freistehend"
        );

      }


      if (
        product.mounts.includes(
          "desktop"
        )
      ) {

        labels.push(
          "Schreibtisch"
        );

      }


      if (
        product.mounts.includes(
          "wall"
        )
      ) {

        labels.push(
          "Wand"
        );

      }


      return labels.join(
        " · "
      );

    }


    function deviceLabel(product) {

      const labels = [];


      if (
        product.devices.includes(
          "laptop"
        )
      ) {

        labels.push(
          "Notebook"
        );

      }


      if (
        product.devices.includes(
          "chromebook"
        )
      ) {

        labels.push(
          "Chromebook"
        );

      }


      if (
        product.devices.includes(
          "tablet"
        )
      ) {

        labels.push(
          "Tablet / iPad"
        );

      }


      if (
        product.devices.includes(
          "phone"
        )
      ) {

        labels.push(
          "Smartphone"
        );

      }


      return labels.join(
        " · "
      );

    }


    /* =========================================================
       RESULTS
       ========================================================= */

    function renderResults(
      productsToShow
    ) {

      resultPlaceholder.style.display =
        "none";

      resultSummary.style.display =
        "block";

      resultList.innerHTML =
        "";


      if (
        !productsToShow.length
      ) {

        resultSummary.textContent =
          "Keine passende Kombination gefunden";


        resultList.innerHTML =

          '<div class="lc-no-results">' +

            'Bitte eine der vorherigen Antworten ändern. ' +

            'Die Auswahlfelder darüber zeigen nur grundsätzlich kombinierbare Optionen.' +

          '</div>';


        return;

      }


      resultSummary.textContent =

        productsToShow.length === 1

          ? "1 passendes Modell gefunden"

          : productsToShow.length +
            " passende Modelle gefunden";


      productsToShow.forEach(
        function (product) {

          const card =
            document.createElement(
              "article"
            );

          card.className =
            "lc-result-card";


          const chargingText =

            product.type === "usb"

              ? product.ports +
                " × USB-C PD"

              : product.ports +
                " × Steckdose";


          const powerText =

            product.type === "usb"

              ? product.watts +
                " W pro Port"

              : "Laden mit vorhandenem Netzteil";


          let pedestalHTML =
            "";


          if (
            product.pedestal
          ) {

            pedestalHTML =

              '<div class="lc-pedestal-result">' +

                '<strong>Optionaler Sockel: </strong>' +

                '<a class="lc-article-link" href="' +

                  product.pedestal.url +

                '">' +

                  product.pedestal.id +

                '</a>' +

              '</div>';

          }


          let mountNoteHTML =
            "";


          if (
            product.mountNote
          ) {

            mountNoteHTML =

              '<div class="lc-result-mount-note">' +

                product.mountNote +

              '</div>';

          }


          card.innerHTML =

            '<div class="lc-result-main">' +

              '<h4>' +

                '<a href="' +

                  product.url +

                '">' +

                  product.name +

                '</a>' +

              '</h4>' +

              '<a class="lc-result-id" href="' +

                product.url +

              '">' +

                'Artikel ' +

                product.id +

              '</a>' +

            '</div>' +


            '<div class="lc-result-details">' +

              '<div class="lc-result-tags">' +

                '<span class="lc-result-tag">' +

                  chargingText +

                '</span>' +

                '<span class="lc-result-tag">' +

                  powerText +

                '</span>' +

                '<span class="lc-result-tag">' +

                  lockLabel(
                    product
                  ) +

                '</span>' +

              '</div>' +


              '<p class="lc-result-copy">' +

                '<strong>Geeignet für: </strong>' +

                deviceLabel(
                  product
                ) +

              '</p>' +


              '<p class="lc-result-copy">' +

                '<strong>Aufstellung: </strong>' +

                mountLabel(
                  product
                ) +

              '</p>' +


              '<p class="lc-result-copy">' +

                '<strong>Fachabmessungen: </strong>' +

                formatDimension(
                  product.dimensions[0]
                ) +

                ' (T) × ' +

                formatDimension(
                  product.dimensions[1]
                ) +

                ' (B) × ' +

                formatDimension(
                  product.dimensions[2]
                ) +

                ' (H) mm' +

              '</p>' +


              mountNoteHTML +

              pedestalHTML +

            '</div>' +


            '<div class="lc-result-action">' +

              '<a class="lc-btn lc-btn--primary" href="' +

                product.url +

              '">' +

                'Produkt ansehen' +

              '</a>' +

            '</div>';


          resultList.appendChild(
            card
          );

        }
      );

    }


    /* =========================================================
       EVENTS
       ========================================================= */

    order.forEach(
      function (fieldName) {

        fields[fieldName]
          .addEventListener(
            "change",
            function () {

              rebuildAfter(
                fieldName
              );

            }
          );

      }
    );


    form.addEventListener(
      "submit",
      function (event) {

        event.preventDefault();


        const criteria =
          currentCriteria();


        let matches =
          products.filter(
            function (product) {

              return matchesCriteria(
                product,
                criteria
              );

            }
          );


        /*
         * Ergebnisse zuerst nach Anzahl der Ladeplätze,
         * danach nach Leistung sortieren.
         */
        matches.sort(
          function (a, b) {

            if (
              a.ports !== b.ports
            ) {

              return (
                a.ports -
                b.ports
              );

            }


            return (
              (a.watts || 999) -
              (b.watts || 999)
            );

          }
        );


        renderResults(
          matches
        );

      }
    );


    resetButton.addEventListener(
      "click",
      function () {

        form.reset();


        order.forEach(
          function (fieldName) {

            rebuildSelect(
              fieldName
            );

          }
        );


        updatePowerVisibility();

        updateStatus();


        resultList.innerHTML =
          "";

        resultSummary.style.display =
          "none";

        resultSummary.textContent =
          "";

        resultPlaceholder.style.display =
          "block";

      }
    );


    /* =========================================================
       INITIALIZE
       ========================================================= */

    order.forEach(
      function (fieldName) {

        rebuildSelect(
          fieldName
        );

      }
    );


    updatePowerVisibility();

    updateStatus();

  }


  /* =========================================================
     START
     ========================================================= */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initManhattanChargingFinder,
      {
        once: true
      }
    );

  } else {

    initManhattanChargingFinder();

  }

})();